module.exports = __webpack_public_path__ + "img/symbol.a8da931f.svg";